// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener,
  forwardRef
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

@Component({
  selector: 'eg-dropdown',
  templateUrl: './eg-dropdown.component.html',
  styleUrls: ['./eg-dropdown.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EgDropdownComponent),
      multi: true
    }
  ],
  standalone: false
})
export class EgDropdownComponent implements ControlValueAccessor {
  @Input() items: { label: string; value: string }[] = [];
  @Input() placeholder = 'Select an option';

  @Output() selectionChange = new EventEmitter<string>();

  isOpen = false;
  selectedValue: string | null = null;
  @Input() selectedLabel: string | null = null;

  private onChange = (_: any) => { };
  private onTouched = () => { };

  toggleDropdown(event: Event) {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  selectItem(item: { label: string; value: string }) {
    this.selectedValue = item.value;
    this.selectedLabel = item.label;
    this.isOpen = false;

    this.onChange(this.selectedValue);
    this.onTouched();
    this.selectionChange.emit(this.selectedValue);
  }

  writeValue(value: string): void {
    this.selectedValue = value;
    const selected = this.items.find(i => i.value === value);
    this.selectedLabel = selected ? selected.label : null;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Optionally implement if you want to handle disabled state
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.custom-dropdown')) {
      this.isOpen = false;
    }
  }
}
